import { api } from "./api";

/** Robust guardian switch-back: gets a FRESH parent token from the backend
 * (works even if the stored parent token expired), with stored-token fallback. */
export async function guardianSwitchBack() {
  const parentTok = localStorage.getItem("icard_token_parent");
  const switchTok = localStorage.getItem("icard_guardian_switch");
  let token = null;
  if (switchTok) {
    try {
      const r = await api.post("/guardian/switch-back", { switch_token: switchTok });
      token = r.data.token;
    } catch (_) { /* fall back to the stored token */ }
  }
  if (!token && parentTok && parentTok !== "null" && parentTok !== "undefined") token = parentTok;
  localStorage.removeItem("icard_token_parent");
  localStorage.removeItem("icard_guardian_child");
  localStorage.removeItem("icard_guardian_switch");
  if (token) {
    localStorage.setItem("icard_token", token);
    window.location.href = "/app/guardian";
  } else {
    localStorage.removeItem("icard_token");
    window.location.href = "/auth";
  }
}
